<section class="mx-3">
  <app-toast></app-toast>
  <mat-dialog-content class="mat-typography" style="overflow-y: auto; max-height: 80vh">
    <div class="d-flex align-items-center mb-3">
      <h2 class="m-0" translate>Add Subject</h2>
    </div>
    <ng-template *ngIf="errorMessage">
      <small class="text_color_red">{{ errorMessage }}</small>
    </ng-template>
    <form [formGroup]="form">
      <div class="row">
        <div *ngFor="let question of questions" class="mb-3 col-sm-12">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="form-row">
      <button mat-stroked-button (click)="closeDialog()" class="px-5 cancel_button" translate>Cancel</button>
      <button *ngIf="!editflag" mat-raised-button color="primary" class="px-5 submit_button" (click)="onSubmit(editflag)" type="submit" [disabled]="!form.valid" translate>Submit</button>
      <button *ngIf="editflag" mat-raised-button color="primary" class="px-5 update_button" (click)="onSubmit(editflag)" type="submit" [disabled]="!form.valid" translate>Update</button>
    </div>
  </mat-dialog-actions>
</section>
